import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/icons/close.svg'


const _hoisted_1 = {
  key: 0,
  class: "flex justify-center items-center fixed inset-y-0 right-0 overflow-x-hidden overflow-y-hidden z-50 w-full"
}
const _hoisted_2 = { class: "flex relative w-1/3 h-auto" }
const _hoisted_3 = { class: "flex flex-col bg-white w-full h-auto rounded-2xl shadow p-8" }
const _hoisted_4 = { class: "flex flex-row justify-between items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "txt-card-title" }, "Add emergency contact", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "mt-4" }
const _hoisted_9 = { class: "mt-4" }
const _hoisted_10 = { class: "mt-4" }
const _hoisted_11 = { class: "mt-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 mt-8" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn-filled-lg mt-4"
}, " Create contact ", -1)
const _hoisted_14 = {
  key: 1,
  class: "bg-black opacity-50 fixed inset-y-0 right-0 z-40 w-full"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextField = _resolveComponent("TextField")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.openModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                }, _hoisted_7)
              ]),
              _createElementVNode("form", {
                onSubmit: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args))),
                class: "mt-8"
              }, [
                _createElementVNode("div", null, [
                  _createVNode(_component_TextField, {
                    modelValue: _ctx.first_name,
                    name: "first_name",
                    label: "First name",
                    error: _ctx.errors.first_name
                  }, null, 8, ["modelValue", "error"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_TextField, {
                    modelValue: _ctx.last_name,
                    name: "last_name",
                    label: "Last name",
                    error: _ctx.errors.last_name
                  }, null, 8, ["modelValue", "error"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_TextField, {
                    modelValue: _ctx.phone,
                    name: "phone",
                    label: "Phone",
                    error: _ctx.errors.phone
                  }, null, 8, ["modelValue", "error"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_TextField, {
                    modelValue: _ctx.relationship,
                    name: "relationship",
                    label: "Relationship",
                    error: _ctx.errors.relationship
                  }, null, 8, ["modelValue", "error"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_TextField, {
                    modelValue: _ctx.address,
                    name: "address",
                    label: "Address (Optional)"
                  }, null, 8, ["modelValue"])
                ]),
                _hoisted_12,
                _hoisted_13
              ], 32)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.openModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14))
      : _createCommentVNode("", true)
  ]))
}